import React, { useEffect, useState } from 'react';
import Select from "react-select";
import "../pages/recruitment/RecruitmentCardKam.css";

const SelectOption = ({value, data, placeholder, handleChange}) => {
    const [options, setOptions] = useState([data]);
    let selectedValue = "";

    useEffect(() => {
        const arr = data.map(item => ({ value: item.id, label: item.name }));
        setOptions(arr);
    }, [data]);

    options.forEach((o) => {
        if (value != null && value !== "" && o.value === value) {
            selectedValue = {value: o.value, label: o.label, id:o.id};
        }
    })
        return (
        <Select
            className="input-cont"
            placeholder={placeholder}
            options={options}
            isClearable={true}
            noOptionsMessage={() => "Not found"}
            onChange={handleChange}
            value={selectedValue}
        />
    );
};

export default SelectOption;
